module.exports = __webpack_public_path__ + "static/media/distribute_icon.ef58d2e8.svg";